import * as React from 'react';

function SvgShare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20 8h-5v2h3v11H6V10h3V8H4v15h16V8z" fill="currentColor" />
      <path d="M11 16h2V5h3l-4-4-4 4h3v11z" fill="currentColor" />
    </svg>
  );
}

export default SvgShare;
